<template>
    <MDBRow>
        <MDBCol cols="12" lg="6" xl="4" class="mb-4" v-for="(training, i) in trainings" :key="i"
            :class="`${training.show ? '' : 'd-none'}`">
            <Card :data="training" :simpleLink="training.simpleLink" minHeight="container-height"
                :linkText="training?.buttonText ?? $t('global.buttons.discover')" :target="training.target" />
        </MDBCol>
    </MDBRow>
</template>

<script setup>
import Card from "@/components/General/Card/index.vue";
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import { computed } from "vue";
import { useI18n } from 'vue-i18n'
import { useTenantConfig } from "@/composables/useTenantConfig";
const { tenantConfig } = useTenantConfig();
const { t } = useI18n();

const trainings = computed(() => {
    return [
        {
            name: t("media.mediasPage.bDrive.title"),
            link: 'https://www.b-drive.com',
            description: t("media.mediasPage.bDrive.description"),
            image: require("@/assets/img/ProduktabbildungenAndLogo.png"),
            show: tenantConfig.value.showBDrive,
            simpleLink: true,
            buttonText: t("global.buttons.toBDrive"),
            target: '_blank',
        },
        {
            name: t("media.title"),
            link: { name: "media" },
            description: t("media.short_description"),
            image: require("@/assets/img/media/bs_document-download-icon.svg"),
            show: true,
            simpleLink: false,
            buttonText: t("media.buttons.media"),
        },
        {
            name: t("priceList.productInfo.index.categories.dataGenereate.title"),
            link: 'https://bridgestonepmbscer.northeurope.cloudapp.azure.com/datasheet/index.php?',
            description: t(
                "priceList.productInfo.index.categories.dataGenereate.description"
            ),
            image: require(`@/assets/img/data_generate.png`),
            show: tenantConfig.value.showDataGenerator,
            linkText: t("global.buttons.toDiscover"),
            simpleLink: true,
            target: "_blank",
        },
    ];
});
</script>
<style scoped lang="scss">
@import "@/styles/_variables.scss";
</style>
